import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import superagent from 'superagent';
import each from 'lodash/each';
import ACTIONS from '../../store/actions';
import Utils from '../../utils';

function authorizeSuperAgentRequest(req, actionRequest, state) {
  var _state$auth = state.auth,
      token = _state$auth.token,
      environmentName = _state$auth.environmentName,
      microserviceId = _state$auth.microserviceId,
      ecrionServer = _state$auth.ecrionServer;

  if (token) {
    if (actionRequest.auth === 'field') req.field('accessToken', token);else req.set('Authorization', 'Basic ' + btoa(token));
  } else {
    // withCredentials is not mandatory, by default is true
    if (typeof actionRequest.withCredentials == 'undefined' || actionRequest.withCredentials !== false) req.withCredentials();
  }

  environmentName && req.set('X-Ecrion-EnvironmentName', environmentName);
  microserviceId && req.set('X-Ecrion-ApplicationId', microserviceId); //Pass Ecrion cloud instance URL to microservice backend

  if (actionRequest.useMicroserviceBackend) req.set('X-Ecrion-CloudInstance', ecrionServer);
  setCSRFValues(req);
  return req;
}

function setCSRFValues(req) {
  var csrfToken = '_csrf';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    if (!c) continue;

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    var cookieKeyValue = c.split('=');

    if (cookieKeyValue[0].indexOf(csrfToken) == -1) {
      continue;
    }

    req.set('X-' + cookieKeyValue[0], cookieKeyValue[1]);
  }
}

function getUrl(actionRequest) {
  if (typeof actionRequest.url !== 'string') throw new Error('URL is required to perform the request');

  if (actionRequest.url.startsWith('/')) {
    var host = Utils.getHost({
      useMicroserviceBackend: actionRequest.useMicroserviceBackend
    });
    if (host.endsWith('/')) host = host.substring(0, host.length - 1);
    return host + actionRequest.url;
  }

  return actionRequest.url;
}

function getSuperAgentRequest(store, actionRequest) {
  var req = superagent(actionRequest.method || 'GET', getUrl(actionRequest));
  req = authorizeSuperAgentRequest(req, actionRequest, store.getState());
  if (actionRequest.contentType === 'json') req = req.type('json');else if (actionRequest.contentType === 'form') req = req.type('form');
  if (actionRequest.query) req = req.query(actionRequest.query);
  if (actionRequest.headers) req = req.set(actionRequest.headers);
  if (actionRequest.binaryRequest) req = req.responseType('blob');

  if (actionRequest.fields) {
    each(actionRequest.fields, function (field) {
      return req = req.field(field.name, field.value);
    });
  }

  if (actionRequest.attach) each(actionRequest.attach, function (val, name) {
    return req = req.attach(name, val);
  });
  if (actionRequest.data) req = req.send(actionRequest.data);
  return req;
}

export var apiMiddleware = function apiMiddleware(store) {
  return function (next) {
    return function (action) {
      var saRequests = [];

      if (typeof action.request !== 'undefined') {
        saRequests.push(getSuperAgentRequest(store, action.request));
      } else if (typeof action.requests !== 'undefined') {
        each(action.requests, function (request) {
          return saRequests.push(getSuperAgentRequest(store, request));
        });
      } else {
        return next(action);
      }

      next(action);
      var state = store.getState();
      return Promise.all(saRequests).then(function (res) {
        if (action.request) {
          onFinish(action, res[0]);
          return res[0];
        } else if (action.requests) {
          var responses = {};
          var reqIdx = 0;
          each(action.requests, function (request, requestName) {
            return responses[requestName] = res[reqIdx++];
          });
          onFinish(action, responses);
          return responses;
        }

        return null;
      }).catch(function (error) {
        if (!state.auth.disableAuthRedirect && error.status === 401) {
          return store.dispatch({
            type: ACTIONS.AUTH_SET_UNAUTHORIZED,
            payload: error
          });
        } else {
          throw error;
        }
      });
    };
  };
};

var onFinish = function onFinish(action, response) {
  if (!action.onFinish) return;
  action.onFinish(response);
}; // if a File is present as one of the action.request.data values,
// the request will be converted to multi part (using superagent fields and attach)


var multipart = function multipart() {
  return function (next) {
    return function (action) {
      if (typeof action.request === 'undefined' || typeof action.requests !== 'undefined') return next(action);
      var useMultipart = false;

      if (action.request.contentType === 'multipart') {
        useMultipart = true;
      } else if (action.request.data) {
        if (typeof action.request.data === 'object') {
          if (Object.values(action.request.data).find(function (el) {
            return el instanceof Blob;
          })) useMultipart = true;
        }
      }

      var newAction = action;

      if (useMultipart) {
        //files from data
        var attach = {}; //the rest of data

        var fields = [];
        each(action.request.data, function (val, name) {
          if (typeof val === 'undefined' || val === null) return;
          if (val instanceof Blob) attach[name] = val;else fields.push({
            name: name,
            value: val
          });
        });
        newAction = _objectSpread({}, action, {
          request: _objectSpread({}, action.request, {
            data: undefined,
            attach: attach,
            fields: fields
          })
        });
      }

      return next(newAction);
    };
  };
};

export default [multipart, apiMiddleware];